import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import {SoilAnalysisFile, SoilAnalysisPreUploadFile} from './models/soil-analysis-file';
import {ShareStateEntityModel} from '../../_shared/models/share-state-entity.model';

export interface SoilAnalysisUploadState extends EntityState<SoilAnalysisFileItem> {
  loading: boolean;
  error: string;
}

export type SoilAnalysisFileItem = ShareStateEntityModel<SoilAnalysisFile> | ShareStateEntityModel<SoilAnalysisPreUploadFile>;

@Injectable({providedIn: 'root'})
@StoreConfig({ name: 'soil-analysis-upload', resettable: true })
export class SoilAnalysisUploadStore extends EntityStore<SoilAnalysisUploadState, SoilAnalysisFileItem> {
  constructor() {
    super({loading : false, error: null});
  }
}
